import {
  Button,
  createTableColumn,
  TableCellLayout,
  TableColumnDefinition,
  Tag,
} from "@fluentui/react-components";
import React, { useEffect, useState } from "react";
import { ITeamMemberDto } from "../../../Models/ITeamMemberDto";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { DeleteRegular, PersonSettingsRegular } from "@fluentui/react-icons";
import { ITeamDto } from "../../../Models/ITeamDto";
import i18n from "i18next";
import DialogRemoveMember from "./DialogRemoveMember";
interface ITeamMemberColumns {
  hover: string;
  deleteInviteEmail(item: string): void;
  selectedTeam?: ITeamDto;
  currentUser?: IAppUserDto;
  deleteMember(item: string): void;
}

export function TeamMemberColumns(props: ITeamMemberColumns) {
  const columns: TableColumnDefinition<ITeamMemberDto>[] = [
    createTableColumn<ITeamMemberDto>({
      columnId: "nameId",
      compare: (a, b) => {
        if (a.nachname && b.nachname) {
          return a.nachname.localeCompare(b.nachname);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Name";
      },
      renderCell: (item) => {
        return (
          <div>
            {item.nachname} {item.vorname}
            {item.id == props.selectedTeam?.teamOwnerId && (
              <Tag
                style={{
                  marginLeft: "10px",
                }}
                appearance="brand"
              >
                <PersonSettingsRegular
                  fontSize={20}
                  style={{ marginBottom: "2px", marginLeft: "3px" }}
                />
                {i18n.t<string>("teamOwner")}
              </Tag>
            )}
          </div>
        );
      },
    }),
    createTableColumn<ITeamMemberDto>({
      columnId: "mailId",
      compare: (a, b) => {
        if (a.email && b.email) {
          return a.email.localeCompare(b.email);
        } else return 0;
      },
      renderHeaderCell: () => {
        return "Email Adresse";
      },
      renderCell: (item) => {
        return <div>{item.email}</div>;
      },
    }),
    createTableColumn<ITeamMemberDto>({
      columnId: "deleteId",

      renderHeaderCell: () => {
        return "";
      },
      renderCell: (item) => {
        var member;
        var invited;
        if (props.selectedTeam) {
          member = props.selectedTeam.members.includes(item);
          invited = props.selectedTeam.invited.includes(item);
        }
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            {
              /* props.hover == item.email && */
              props.currentUser &&
                props.currentUser.id == props.selectedTeam?.teamOwnerId &&
                item.id != props.selectedTeam?.teamOwnerId && (
                  <DialogRemoveMember
                    onDeleteMember={() => {
                      props.deleteMember(item.id);
                    }}
                    onRemoveInvite={() => {
                      props.deleteInviteEmail(item.email);
                    }}
                    userIsInvited={invited}
                    userIsMember={member}
                  />
                )
            }
          </div>
        );
      },
    }),
  ];
  return columns;
}
